<template>
  <a-row>
    <a-col :span="24" class="step">
      <a-steps :current="current">
        <a-step>
          <template #title><span>{{ $t('js.diem_don_tra') }}</span></template>
        </a-step>
        <a-step>
          <template #title><span>{{ $t('js.nhap_thong_tin') }}</span></template>
        </a-step>
      </a-steps>
    </a-col>
    <a-col :span="24" class="content">
      <a-row v-if="current == 0" style="height:100%">
        <a-col :span="12" class="item-content">
          <a-row :gutter="[0, 8]" style="height:88%">
            <a-col :span="24"><span class="title">{{ $t('js.diem_don') }}</span></a-col>
            <a-col
              v-if="
                destinationLocation.length == 0 && listDetailLoading == false
              "
              :span="24"
            >
              <a-row
                type="flex"
                justify="center"
                align="middle"
                style="min-height: 200px"
              >
                <a-empty :description="$t('js.khong_co_diem_don_phu_hop')" />
              </a-row>
            </a-col>
            <a-col v-if="listDetailLoading" :span="24">
              <a-skeleton active />
            </a-col>
            <a-col :span="24" class="location-radio" v-else>
              <a-radio-group v-model:value="destinationSelected">
                <a-row
                  v-for="des in sortTime(destinationLocation)"
                  :key="des.id"
                  :gutter="[0, 16]"
                >
                  <a-col :span="24">
                    <a-row align="middle">
                      <a-radio
                        @click="getAmount(des.amount,'des')"
                        :style="radioStyle"
                        :value="des.id"
                      >
                        <span>
                          <img
                            class="location-img"
                            :src="require('@/assets/img/location.png').default"
                            alt=""
                          />
                          <b>
                            {{ des.time.slice(0,5) }}
                          </b>
                          -
                          <span
                            :class="[des.is_transit == 1 ? 'transit' : '']"
                            >{{ des.title }}</span
                          >
                        </span>
                      </a-radio>
                    </a-row>
                  </a-col>
                </a-row>
              </a-radio-group>
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="12" class="item-content">
          <a-row :gutter="[0, 8]" style="height:88%">
            <a-col :span="24"><span class="title">{{ $t('js.diem_tra') }}</span></a-col>
            <a-col
              v-if="arrivalLocation.length == 0 && listDetailLoading == false"
              :span="24"
            >
              <a-row
                type="flex"
                justify="center"
                align="middle"
                style="min-height: 200px"
              >
                <a-empty :description="$t('js.khong_co_diem_tra_phu_hop')" />
              </a-row>
            </a-col>
            <a-col v-if="listDetailLoading" :span="24">
              <a-skeleton active />
            </a-col>
            <a-col :span="24" class="location-radio" v-else>
              <a-radio-group v-model:value="arrivalSelected">
                <a-row
                  v-for="arr in sortTime(arrivalLocation)"
                  :key="arr.id"
                  :gutter="[0, 16]"
                >
                  <a-col :span="24">
                    <a-row>
                      <a-radio @click="getAmount(arr.amount,'arr')" :style="radioStyle" :value="arr.id">
                        <span>
                          <img
                            class="location-img"
                            :src="require('@/assets/img/location.png').default"
                            alt=""
                          />
                          <b>
                            {{ arr.time.slice(0,5) }}
                          </b>
                          -
                          <span
                            :class="[arr.is_transit == 1 ? 'transit' : '']"
                            >{{ arr.title }}</span
                          >
                        </span>
                      </a-radio>
                    </a-row>
                  </a-col>
                </a-row>
              </a-radio-group>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <a-row v-if="current == 1">
        <a-col :offset="2" :span="20">
          <a-row :gutter="[0, 16]">
            <a-col :span="24">
              <a-row :gutter="[8, 0]">
                <a-col><span class="title-input">{{ $t('js.ho_va_ten') }}</span></a-col>
                <a-col><span class="title-hot-input">*</span></a-col>
              </a-row>
              <a-row>
                <a-input v-model:value="fullName" :placeholder="$t('js.ho_va_ten')" />
              </a-row>
            </a-col>
            <a-col :span="24">
              <a-row :gutter="[8, 0]">
                <a-col><span class="title-input">{{ $t('js.so_dien_thoai') }}</span></a-col>
                <a-col><span class="title-hot-input">*</span></a-col>
              </a-row>
              <a-row>
                <a-input
                  v-model:value="phoneNumber"
                  type="number"
                  :maxlength="10"
                  :placeholder="$t('js.so_dien_thoai')"
                />
              </a-row>
            </a-col>
            <a-col :span="24">
              <a-row :gutter="[8, 0]">
                <a-col><span class="title-input">Email</span></a-col>
                <a-col><span class="title-hot-input">*</span></a-col>
              </a-row>
              <a-row>
                <a-input v-model:value="email" placeholder="Email" />
              </a-row>
            </a-col>
            <a-col :span="24">
              <a-row :gutter="[8, 0]">
                <a-col><span class="title-input">{{ $t('js.ghi_chu') }}</span></a-col>
                <!-- <a-col><span>*</span></a-col> -->
              </a-row>
              <a-row>
                <a-textarea
                  v-model:value="note"
                  :placeholder="$t('js.nhap_ghi_chu')"
                  :rows="4"
                />
              </a-row>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-col>
    <a-col :span="24" class="footer">
      <a-row type="flex" justify="space-between" align="middle">
        <a-col
          ><a-row :gutter="[8, 0]" v-if="current > 0" align="middle">
            <a-col>
              <LeftOutlined />
            </a-col>
            <a-col>
              <span @click="current--">{{ $t('js.quay_lai_8a09e03d') }}</span>
            </a-col>
          </a-row>
          <a-row
            :gutter="[8, 0]"
            v-if="current == 0"
            align="middle"
            class="quantity-container"
          >
            <a-col>
              <span class="amount">{{ $t('js.so_luong') }}</span>
            </a-col>
            <a-col>
              <a-row :gutter="[8, 0]" align="middle">
                <a-col>
                  <MinusCircleOutlined
                    style="font-size: 16px"
                    @click="minusQuantity()"
                  />
                </a-col>
                <a-col class="quantity">
                  <span>{{ quantity }}</span>
                </a-col>
                <a-col>
                  <PlusCircleOutlined
                    style="font-size: 16px"
                    @click="quantity++"
                  />
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </a-col>
        <a-col>
          <a-row :gutter="[8, 0]" align="middle">
            <a-col>
              <span class="total">{{ $t('js.tong_cong') }}</span>
            </a-col>
            <a-col>
              <span class="cost">{{ formatNumber(totalAmount) }} {{ $t('js.d') }}</span>
            </a-col>
            <a-col>
              <a-button v-if="current == 0" type="primary" @click="next()"
                ><span>{{ $t('js.tiep_tuc') }}</span></a-button
              >
              <a-button
                v-if="current == 1"
                type="primary"
                @click="booking"
                :loading="registerLoading"
                ><span>{{ $t('js.dat_ve') }}</span></a-button
              >
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>
<script setup>
import { computed, onMounted, ref, watch, watchEffect } from "vue";
import {
  DownOutlined,
  UpOutlined,
  LeftOutlined,
  ClockCircleOutlined,
  PlusCircleOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons-vue";
import { formatNumber, formatTime, renderImg } from "@/utility";
import { message, Modal } from "ant-design-vue";
import moment, { Moment } from "moment";
import TicketReservationsService from "@/services/TicketReservationsService";
import { notification } from "ant-design-vue";
const props = defineProps({
  item: Object,
  current: Number,
  destinationLocation: Array,
  arrivalLocation: Array,
  listDetailLoading: Boolean,
  dateValue: Moment,
});
const current = ref(0);
const destinationSelected = ref();
const arrivalSelected = ref();
const quantity = ref(1);
const fullName = ref("");
const phoneNumber = ref("");
const email = ref("");
const note = ref("");
const registerLoading = ref(false);
const destinationAmount = ref(0);
const arrivalAmount = ref(0);
const totalAmount = computed(() => {
  if (arrivalAmount.value > destinationAmount.value) {
    return (
      quantity.value *
      (parseInt(arrivalAmount.value) - parseInt(destinationAmount.value))
    );
  } else {
    return 0;
  }
});
const getAmount = (amount, type) => {
  if (type == "des") {
    if (amount !== null) {
      destinationAmount.value = amount;
    } else {
      destinationAmount.value = 0;
    }
  }
   if (type == "arr") {
    if (amount !== null) {
      arrivalAmount.value = amount;
    } else {
      arrivalAmount.value = 0;
    }
  }
};
const sortTime = (array) =>{
 return array.sort((a,b) => a.time.localeCompare(b.time));
}
const params = computed(() => {
  let data = {
    road_id: props.item.road_id,
    mobile_no: phoneNumber.value,
    customer_name: fullName.value,
    email: email.value,
    location_destination_id: destinationSelected.value,
    location_arrival_id: arrivalSelected.value,
    amount: totalAmount.value,
    seat_quantity: quantity.value,
    start_date: props.dateValue.format("YYYY-MM-DD"),
    start_time: props.item.start_time,
    end_time: props.item.end_time,
    total_time: props.item.total_time,
    note: note.value,
  };
  return data;
});

const minusQuantity = () => {
  if (quantity.value > 1) {
    quantity.value--;
  }
};
const next = () => {
  if (
    destinationSelected.value == undefined &&
    arrivalSelected.value == undefined
  ) {
    message.error(window.__t('js.ban_chua_chon_diem_don_tra'));
  } else if (destinationSelected.value == undefined) {
    message.error(window.__t('js.ban_chua_chon_diem_don'));
  } else if (arrivalSelected.value == undefined) {
    message.error(window.__t('js.ban_chua_chon_diem_tra'));
  } else {
    current.value++;
  }
};
const booking = () => {
  if (fullName.value == "" || phoneNumber.value == "" || email.value == "") {
    message.error(window.__t('js.ban_chua_nhap_du_thong_tin_can_thiet'));
  } else {
    registerLoading.value = true;
    TicketReservationsService.booking(params.value)
      .then((res) => {
        if (res.data.errorCode == 0) {
          openNotification(res.data.orderCustomer.code);
          props.item.is_select = true;
          registerLoading.value = false;
        } else {
          message.error(window.__t('js.loi_he_thong'));
          registerLoading.value = false;
        }
      })
      .catch((error) => {
        message.error(error.message);
        registerLoading.value = false;
      });
  }
};
const openNotification = (code) => {
  notification.success({
    message: window.__t('js.dat_don_thanh_cong'),
    description: window.__t('js.cam_on_ban_da_dat_don_hang_cua_chung_toi_ma_don_cua_ban_la_code', {
      code
    }),
    duration: 0,
  });
};
</script>

<style scoped lang="scss">
.step {
  padding-top: 16px;
  padding-bottom: 16px;
  // border-top: 1px solid silver;
  border-bottom: 1px solid silver;
}
.content {
  min-height: 36vh;
  margin-top: 24px;
  margin-bottom: 24px;
  .title-input {
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
  }
  .title-hot-input {
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
    color: red;
  }
  .item-content {
    height: 100%;
    padding-left: 20px;
    padding-right: 20px;
    .title {
      font-weight: 700;
      font-size: 18px;
      text-align: left;
    }
    .location-radio {
      height:100%;
      overflow: scroll;
      overflow-x: hidden;
      .ant-radio-group {
        .ant-radio-wrapper {
          white-space: inherit;
          font-size: 16px;
          display: flex;
          align-items: center;
          .transit {
            color: #0060c4;
          }
          .dot {
            background: black;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            // margin: 0px 8px 0px 8px;
          }
          .time {
            font-weight: 600;
          }
          .location-img {
            width: 24px;
            position: relative;
            bottom: 2px;
            // margin-right: 8px;
          }
        }
      }
    }
  }
}
.footer {
  padding-top: 8px;
  border-top: 1px solid silver;
  .total {
    font-size: 16px;
  }
  .quantity-container {
    .amount {
      font-size: 16px;
    }
    .quantity {
      font-weight: 700;
      font-size: 16px;
      color: #0060c4;
    }
  }
  .cost {
    color: #0060c4;
    font-weight: 700;
    font-size: 16px;
  }
}
</style>
